import { defineMessages } from 'react-intl';

export default defineMessages({
    covMiscellaneous: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Miscellaneous.Coverages',
        defaultMessage: 'Coverages'
    },
    formMiscellaneous:{
        id: 'quoteandbind.PPLProLinedirectives.templates.Miscellaneous.Endorsements',
        defaultMessage: 'Endorsements'
    }
});